import { ClipboardList, Download, FileText, HeartPulse, Pill } from 'lucide-react';
import { useAnimationLoop } from './useOnboardingAnim';
import { DEMO_ROOT_CLASS } from './onboardingLayout';

const TAB_PHASES = [1000, 1000, 1000, 1000, 1200];

const TABS = [
  { label: 'Notes', icon: ClipboardList, item: { title: 'SOAP Progress Note', meta: 'Layla · Room 3 · 10:30' } },
  { label: 'Vitals', icon: HeartPulse, item: { title: 'Pain 4/10', meta: 'Layla · Room 3 · 10:42' } },
  { label: 'Meds', icon: Pill, item: { title: 'Paracetamol 1g IV', meta: 'Khalid · Room 8 · 08:00' } },
  { label: 'Reports', icon: FileText, item: { title: 'Shift Handover', meta: '4 patients · Night shift' } },
];

export default function TabsDemoAnimation() {
  const phase = useAnimationLoop(TAB_PHASES);
  const activeIndex = phase % TABS.length;
  const activeTab = TABS[activeIndex];
  const highlightView = phase >= 0;

  return (
    <div className={DEMO_ROOT_CLASS}>
      <div className="flex h-full w-full flex-col justify-center gap-1.5 px-1 sm:gap-2">
      <div
        key={activeIndex}
        className="rounded-lg border border-gray-200 bg-white p-2 shadow-sm onboarding-fade-in"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-[10px] font-semibold">{activeTab.item.title}</p>
            <p className="text-[8px] text-gray-500">{activeTab.item.meta}</p>
          </div>
          <button
            type="button"
            className={`flex items-center gap-0.5 rounded-full px-2 py-1 text-[8px] font-semibold text-white transition-all duration-300 ${
              highlightView ? 'scale-105 bg-primary shadow-sm' : 'bg-primary'
            }`}
          >
            <Download className="h-2.5 w-2.5" />
            View
          </button>
        </div>
      </div>
      <div className="flex justify-between rounded-t-lg border border-b-0 border-gray-200 bg-surface px-1 pt-2">
        {TABS.map(({ label, icon: Icon }, index) => (
          <div
            key={label}
            className={`flex flex-1 flex-col items-center gap-0.5 py-1 transition-colors duration-300 ${
              index === activeIndex ? 'text-navy' : 'text-gray-400'
            }`}
          >
            <Icon className="h-4 w-4" strokeWidth={2} />
            <span className="text-[7px] font-semibold">{label}</span>
            {index === activeIndex && (
              <span className="h-0.5 w-4 rounded-full bg-navy" />
            )}
          </div>
        ))}
      </div>
      </div>
    </div>
  );
}
